import { render } from "./InfoCard.vue?vue&type=template&id=5c759656&scoped=true"
import script from "./InfoCard.vue?vue&type=script&lang=js"
export * from "./InfoCard.vue?vue&type=script&lang=js"

import "./InfoCard.vue?vue&type=style&index=0&id=5c759656&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c759656"]])

export default __exports__